import { useState, useEffect } from "react";
import { PrinterManager } from "managers/PrinterManager";
import { eventsEmitter } from "utils/events";
import { EVENTS } from "const";

export default function usePrinterQueue() {
  const [queues, setQueues] = useState(PrinterManager.queues);

  useEffect(() => {
    // Subscribe to realtime updates from eventsEmitter bus
    const unsubscribe = eventsEmitter.on(EVENTS.PRINTER_QUEUE_UPDATED, (updatedQueues) => {
      setQueues(updatedQueues);
    });

    // Initial state set
    setQueues(PrinterManager.queues);

    return () => {
      unsubscribe();
    };
  }, []);

  const clearAllQueue = async () => {
    await PrinterManager.clearAllQueues();
  };

  const stopAllQueues = () => {
    PrinterManager.stopAllQueues();
  };

  const startAllQueues = () => {
    PrinterManager.startAllQueues();
  };

  const clearPrintJob = async (jobId) => {
    await PrinterManager.clearPrintJob(jobId);
  };

  return { queues, clearAllQueue, stopAllQueues, startAllQueues, clearPrintJob };
}
